import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export type UnsavedChangesAction = 'stay' | 'discard' | 'save';

export interface UnsavedChangesOptions {
  title?: string;
  message?: string;
  stayText?: string;
  discardText?: string;
  saveText?: string;
}

interface UnsavedChangesRequest {
  options: UnsavedChangesOptions;
  result: Subject<UnsavedChangesAction>;
}

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesService {
  private requestSubject = new Subject<UnsavedChangesRequest>();
  readonly request$ = this.requestSubject.asObservable();

  prompt(options?: UnsavedChangesOptions): Observable<UnsavedChangesAction> {
    const result = new Subject<UnsavedChangesAction>();
    const finalOptions: UnsavedChangesOptions = {
      title: 'Alterações não salvas',
      message: 'Existem alterações que ainda não foram salvas. O que deseja fazer?',
      stayText: 'Continuar editando',
      discardText: 'Sair sem salvar',
      saveText: 'Salvar e sair',
      ...options
    };

    this.requestSubject.next({ options: finalOptions, result });
    return result.asObservable();
  }
}
